//import type { AppState } from 'src/app/store'

import { MessagesSliceState } from 'src/core/models'

const messagesState: MessagesSliceState = {
  messages: {
    loading: false,
    messages: [],
    filteredMessages: [],
    filterText: '',
    count: null,
  },
  sendMessage: {
    loading: false,
    success: false,
    error: null,
  },
  readMessage: {
    loading: false,
    success: false,
    currentMessage: 0
  }
}


export { messagesState as initialState }
